/** Avatar de iniciais (nome → até 2 letras). Decorativo: o nome fica ao lado. */
import { createElement as h, type ReactElement } from "react";

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

export function Avatar({ name }: { name: string }): ReactElement {
  return h(
    "span",
    {
      "aria-hidden": true,
      className: "grid h-[32px] w-[32px] shrink-0 place-items-center rounded-pill bg-brand-wash text-xs font-extrabold text-brand-text"
    },
    initialsOf(name)
  );
}
